import axios from './axios';

function search(search) {
    return axios().get("/suppliers-search", { params: { search, relations: ["accounts"] } })
}

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;

    return axios().get("/suppliers", { params })
}

function create(data) {
    return axios().post("/suppliers", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });
}

function update(data) {
    return axios().put(`/suppliers/${data.id}`, data);
}

function find(id) {
    return axios().get(`suppliers/${id}`, { params: {
        relations: ["accounts", "contacts"]
    } });
}
function remove(supplier) {
    return axios().delete(`/suppliers/${supplier.id}`)
}

export default {
    search,
    find,
    create,
    update,
    remove,
    index
}